
import IconButton from 'components/atoms/button/IconButton';
import Form from 'components/atoms/form/Form';
import withModal from 'lib/helpers/hoc/withModal'

import React, { FC } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Icon from 'components/atoms/icon/Icon';
import { IconType } from 'lib/helpers/constants/iconTypes';
import { useAddComparison } from 'lib/hooks/mutations/Finances/useAddComparison';
import CurrencyInput from 'components/atoms/input/currency-input/CurrencyInput';

export interface IAddNewCostProps {
    onConfirm: () => void;
    title?: string;

}
const AddNewCost: FC<IAddNewCostProps> = ({ onConfirm, title }) => {

    const { t } = useTranslation();

    const { control,
        formState: { errors },
        handleSubmit,
    } = useForm({
        defaultValues: {
            head_section: title,
            section: 'Cost',
            cost_1: '',
            cost_2: '',
            cost_3: '',
        }
    });

    const { mutateAsync, isLoading } = useAddComparison()

    const onSubmit = (data: any) => {


        mutateAsync(data).then(() => {
            onConfirm();
        })
    };




    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-0 flex flex-col gap-5">



                <Controller
                    name='cost_1'
                    control={control}
                    rules={{
                        required: `${t('Direct cost is required')}`,
                    }}
                    render={({ field }) => (
                        <CurrencyInput
                            prefix="CHF "
                            value={field.value || ""}
                            onValueChange={(value: any) => {
                                field.onChange(value || "");

                            }}
                            label={t('Direct Cost')}
                            placeholder={t('Enter direct cost')}
                            error={errors?.cost_1}
                        />
                    )}
                />
                <Controller
                    name='cost_2'
                    control={control}
                    rules={{
                        required: `${t('Indirect cost is required')}`,
                    }}
                    render={({ field }) => (

                        <CurrencyInput
                            prefix="CHF "
                            value={field.value || ""}
                            onValueChange={(value: any) => {
                                field.onChange(value || "");

                            }}
                            label={t('Indirect Cost')}
                            placeholder={t('Enter indirect cost')}
                            error={errors?.cost_2}
                        />
                    )}
                />

                <Controller
                    name='cost_3'
                    control={control}
                    rules={{
                        required: `${t('Employee Commission is required')}`,
                    }}
                    render={({ field }) => (

                        <CurrencyInput
                            prefix="CHF "
                            value={field.value || ""}
                            onValueChange={(value: any) => {
                                field.onChange(value || "");

                            }}
                            label={t('Employee Commission')}
                            placeholder={t('Enter employee commission')}
                            error={errors?.cost_3}
                        />
                    )}
                />


            </div>
            <div className="flex flex-row justify-end gap-5 pt-10">
                <IconButton className="" type='submit' icon={<Icon iconType={IconType.PLUS_ICON} />} disabled={isLoading}>
                    {t(`Add new cost`)}
                </IconButton>
            </div>
        </Form >
    )
}

export default withModal(AddNewCost)